export default class DefaultState{
  oldPassword = '';
  password = '';
  rePassword = '';
}
